import type { EnrichedMealPeriod, EnrichedMenuItem } from "../../src/types";
import { MenuItem } from "./MenuItem";

function dedup(items: EnrichedMenuItem[]): EnrichedMenuItem[] {
  const seen = new Set<string>();
  return items.filter((it) => {
    const k = `${it.title} ${it.description ?? ""}`;
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
}

export function MealPeriodSection({ mp }: { mp: EnrichedMealPeriod }) {
  const items = dedup(mp.items);
  if (items.length === 0) return null;
  return (
    <section className="mt-3">
      <div className="text-[10px] uppercase tracking-[0.08em] font-semibold text-(--color-ink-3) mb-1">
        {mp.label || mp.name}
      </div>
      <ul className="list-none p-0 m-0 grid gap-1">
        {items.map((it) => (
          <MenuItem key={`${it.title}-${it.description ?? ""}`} item={it} />
        ))}
      </ul>
    </section>
  );
}
